const getters = {
  getFiltersQuery: (state) => (state.query),
  getFiltersQueryUrl: (state) => {
    if (state.index != null && state.query !== '') {
      return {
        wrld_query: state.query
      }
    }
    return null
  },
  getReferenceFiltersQuery: (state) => (state.reference),
  getReferenceFiltersQueryUrl: (state) => {
    if (state.index != null && state.reference !== '') {
      return {
        wrld_ref: state.reference
      }
    }
    return null
  }
}
export default getters
